import { DAdmin } from '../types';
import localforage from 'localforage';
interface IAccountStore {
  // eslint-disable-next-line no-undef
  readonly store: LocalForage;
  account?: DAdmin;
}

class Account implements IAccountStore {
  // eslint-disable-next-line no-undef
  store: LocalForage;

  constructor() {
    this.store = localforage.createInstance({
      name: 'Account',
    });
  }

  async getStore() {
    return (
      (await this.store.getItem<IAccountStore>('store')) ||
      ({} as IAccountStore)
    );
  }

  async get<T extends keyof IAccountStore>(key: T) {
    const storeData = await this.getStore();

    return storeData[key];
  }

  async set<T>(key: keyof IAccountStore, payload: T) {
    const storeData = await this.getStore();
    // @ts-ignore
    storeData[key] = payload;

    return this.store.setItem('store', storeData);
  }
}

export const AccountStore = new Account();
